export enum MediaManagerSDKBoardTeamAvailability {
  On = 'on',
  Off = 'off',
}
